import React from 'react';
import classnames from 'classnames';

// Hooks
import { useResponsiveScreenWidth } from 'Wpds/hooks/useResponsiveScreenWidth';

// Components
import { WpButton } from 'Wpds/components/button';
import WpIcon from 'Wpds/components/icon/WpIcon';
import UserSuggestions from 'Shared/components/UserSuggestions/UserSuggestions';
import DayCalendarMeetings from 'Shared/components/DayCalendarMeetings/DayCalendarMeetings';
import HomePageActionItems from './partials/HomePageActionItems';
import MobileAddButton from 'Shared/components/MobileAddButton/MobileAddButton';

// Styles
import './HomePageContent.scss';

const HomePageContent = () => {
  const baseClassName = 'HomePageContent';

  const { isXtraLarge } = useResponsiveScreenWidth({
    isAtLeast: true,
    breakpoints: { xl: 1360 },
  });

  const { isXtraSmall } = useResponsiveScreenWidth({
    isAtMost: true,
  });

  const classes = classnames(baseClassName, isXtraSmall ? `${baseClassName}--small` : '');

  return (
    <div className={classes}>
      <MobileAddButton inPortal={false}>
        <div className={`${baseClassName}__mobile-add-btn`}>
          <WpButton size="lg" block>
            <WpIcon name="plus" />
            New item
          </WpButton>
        </div>
      </MobileAddButton>

      <div className={`${baseClassName}__row`}>
        <div className={`${baseClassName}__column ${baseClassName}__row__left`}>
          {!isXtraSmall && <UserSuggestions />}
          <div className={`${baseClassName}__row__left__action-items`}>
            <HomePageActionItems />
          </div>
        </div>
        {isXtraLarge && (
          <div className={`${baseClassName}__column ${baseClassName}__row__right`}>
            <div className={`${baseClassName}__row__right__calendar`}>
              <DayCalendarMeetings />
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default HomePageContent;
